import { AppDispatch, RootState } from '@src/store/store'
import { addressApi } from '@src/api/address-api'
import {
  setAddresses,
  setIsLoadingChange,
  setIsLoadingCheck,
  setIsSuccessChange,
  setSuccessInfoConnect,
} from '@src/store/ducks/address/reducer'
import { selectUserServices } from '@src/store/ducks/user/selectors'
import { Store } from 'react-notifications-component'
import { isString } from '@src/lib/utils'
import { errors } from '@src/messages/errors'

export const getAddresses = () => async (dispatch: AppDispatch) => {
  try {
    const result = await addressApi.getAddresses()
    dispatch(setAddresses(result))
  } catch (err) {
    console.error(err)
  }
}
export const postCheckAddress = (
  corpus: string, house: string, street: any, callback: any,
) => async (dispatch: AppDispatch) => {
  try {
    callback(false)
    dispatch(setIsLoadingCheck(true))
    const result = await addressApi.checkAddress(corpus, house, street)
    dispatch(setSuccessInfoConnect(result))
    callback(true)
  } catch (err: any) {
    console.log(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingCheck(false))
  }
}

export const changeAddress = (address: string) => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    dispatch(setIsLoadingChange(true))
    const { tariff } = selectUserServices(getState())
    if (tariff) {
      await addressApi.changeAddress(tariff[0].account, tariff[0].dogovorId, address, tariff[0].goodName)
      dispatch(setIsSuccessChange(true))
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      title: 'Ошибка!',
      message: isString(err?.response?.data) ? err.response.data : errors.main,
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      dismiss: {
        duration: 5000,
      },
    })
  } finally {
    dispatch(setIsLoadingChange(false))
  }
}
